import { render, staticRenderFns } from "./classify_item.vue?vue&type=template&id=7e025112&scoped=true"
import script from "./classify_item.vue?vue&type=script&lang=ts"
export * from "./classify_item.vue?vue&type=script&lang=ts"
import style0 from "./classify_item.vue?vue&type=style&index=0&id=7e025112&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e025112",
  null
  
)

/* custom blocks */
import block0 from "./classify_item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports